import { OptionItem } from 'interfaces/OptionItem';
export type { OptionItem } from 'interfaces/OptionItem';

type Entity = {
  id: string,
}
type OptionSetter = React.Dispatch<React.SetStateAction<OptionItem[]>>;

export function getOptionItems<T extends Entity>(entities: T[], field: (value: T) => void): OptionItem[];
export function getOptionItems<T extends Entity>(entities: T[], field: (value: T) => void, optionSetter: OptionSetter): OptionItem[];
export function getOptionItems<T extends Entity>(entities: T[], field: (value: T) => void, optionSetter?: OptionSetter): OptionItem[] {
  const optionList = entities.map<OptionItem>(x => ({ label: field(x), value: x.id }));
  if (optionSetter) {
    optionSetter(optionList);
  }
  return optionList;
};

export async function getOptionsFromRequest<T extends Entity>(getAllPromise: Promise<T[]>, fieldFunc: (value: T) => void, optionSetter?: OptionSetter): Promise<OptionItem[]> {
  const entities = await getAllPromise;
  if (!entities) return;
  
  const optionList = getOptionItems(entities, fieldFunc);
  if (optionSetter) {
    optionSetter(optionList);
  }
  return optionList;
};
